import { RootState } from "store";
import { createSelector } from "@reduxjs/toolkit";

export const selectTicketingState = (state: RootState) => state.ticketing;

export const selectShowTickets = createSelector(
  selectTicketingState,
  (ticketingState) => ticketingState.showTickets,
);

export const selectIsLoading = createSelector(
  selectTicketingState,
  (ticketingState) => ticketingState.isLoading,
);

export const selectHasTickets = createSelector(
  selectTicketingState,
  (ticketingState) => ticketingState.hasTickets,
);

export const selectHasPayableTicket = createSelector(
  selectTicketingState,
  (ticketingState) =>
    ticketingState.hasTickets &&
    ticketingState.shouldPayForEvent &&
    !ticketingState.hasCurrentUserPlacedTicketOrder,
);
